if(window.innerWidth < 800) {
  $('.pointer-shop-look').on('click', function() {
    $('html').addClass('popup-product-open');
  })
  $('.close-product-popup').on('click', function() {
    $('html').removeClass('popup-product-open');
  })
}

function wishlistEnabler() {
  setTimeout(function(){
    initButtons();
    initGrid();
  }, 500);
}


const shareButton = $('.look-share');

shareButton.on('click', function() {

  let shareTitle = $(this).attr("data-share-title");
  let shareDesc = $(this).attr("data-share-desc");
  let shareImg = $(this).attr("data-share-img");
  let shareURL = $(this).attr("data-share-url");
  console.log(shareTitle, shareDesc, shareImg, shareURL)

  fetch(shareImg)
  .then(function(response) {
    return response.blob()
  })
  .then(function(blob) {

    var file = new File([blob], "picture.jpg", {type: 'image/jpeg'});
    var filesArray = [file];

    if(navigator.canShare && navigator.canShare({ files: filesArray })) {
      navigator.share({
        text: shareTitle + ' - ' + shareDesc,
        files: filesArray,
        title: shareTitle,
        url: shareURL
      });
    } else {
      alert('Sharing not supported on your device')
    }
  })
});

$("ul[data-menu-name='Locations'] li a").attr('target','_blank')
$("ul[data-menu-name='Locations'] li a").addClass('js-no-transition')


function checkVariant() {
  var str = window.location.search
  var mySubString = str.substring(
    str.indexOf("=") + 1
  );
  let activeVariant = $('div[data-id="'+mySubString+'"]');
  let activeQuantity = activeVariant.data("quantity")
  let activePolicy = activeVariant.data("policy")
  if(activeQuantity <= '0' && activePolicy == 'continue') {
    $('.btn.add-to-cart span').text('Pre-Order')
    $('.pre-order-text').show();
  }	else if(activeQuantity <= '0' && activePolicy != 'continue') {
    $('.btn.add-to-cart span').text('Sold out')
    $('.pre-order-text').hide();
  } else {
    $('.btn.add-to-cart span').text('Add to cart')
    $('.pre-order-text').hide();
  }
}
$('.variant__button-label').on('click', function() {
  setTimeout(function(){
    checkVariant()
  }, 10);
})


// Sticky Header JS 

$(document).ready(function () {
  $('.page-width-head + .site-header__element.site-header__element--sub>.page-width').prepend('<div class="sticky_menu_logo"><a href="/" class="site-header__logo-link"><img class="logo" src="//cdn.shopify.com/s/files/1/0550/6554/2881/files/logo_180x.png?v=1633711549" alt="Beruru Pvt Ltd"></a></div>');
  if ($(window).scrollTop() >= 20) {
    $('.sticky_menu_logo').show();
  }
  else {
    $('.sticky_menu_logo').hide();
  }
});


$(window).scroll(function () {
  if ($(window).scrollTop() >= 20) {
    $('.site-header__element.site-header__element--top.page-width-head').hide();
    $('.sticky_menu_logo').show();
  }
  else {
    $('.site-header__element.site-header__element--top.page-width-head').show();
    $('.sticky_menu_logo').hide();
  }
});


// search icon add

// $(document).ready(function () {
//   $('<div class="search-icon__header"><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-search" viewBox="0 0 64 64"><defs><style>.cls-1{fill:none;stroke:#000;stroke-miterlimit:10;stroke-width:2px}</style></defs><path class="cls-1" d="M47.16 28.58A18.58 18.58 0 1 1 28.58 10a18.58 18.58 0 0 1 18.58 18.58zM54 54L41.94 42"></path></svg></div>').appendTo('.page-width-head + .site-header__element.site-header__element--sub>.page-width');                                                                                         
//   if ($(window).scrollTop() >= 20) {
//     $('.search-icon__header').show();
//   }
//   else {
//     $('.search-icon__header').hide();
//   }
// });

$(window).scroll(function () {
  if ($(window).scrollTop() >= 20) {
    $('.desktop-submenu-header').show();
  }
  else {
    $('.desktop-submenu-header').hide();
  }
});


 $(document).on('click', '.btn-wishlist', function() {
    $(this).closest(".active").find('.whishlist-modal');
    $(this).closest('.footer__block').toggleClass('toggled-off');
  });

